import {
	faLocationArrow,
	faLocationCrosshairs,
	faMapLocation,
	faSchool,
	faSuitcase,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { ANCHAL, ANCHAL_STATE_MAPPING, EDUCATION, STATE_DANGER, STATE_DEFAULT, STATES } from "../../utils/constants";
import Button from "../DesignSystem/Button/Button";
import Checkbox from "../DesignSystem/Checkbox/Checkbox";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";
import Dropdown from "../DesignSystem/Dropdown/Dropdown";
import { fetchPincodeDetails } from "../../store/thunks/register";

export default connect((state) => ({ ...state.register }), {
	fetchPincodeDetails,
})(({ fetchingPincodeDetails, pincodeDetails, onNextButtonClick, genericErrorMessage }) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [city, setCity] = useState("");
	const [cityInputState, setCityInputState] = useState("");
	const [cityError, setCityError] = useState("");
	const [presetCity, setPresetCity] = useState("");

	const [state, setState] = useState("");
	const [stateInputState, setStateInputState] = useState("");
	const [stateError, setStateError] = useState("");

	const [address, setAddress] = useState("");
	const [addressInputState, setAddressInputState] = useState("");
	const [addressError, setAddressError] = useState("");

	const [pincode, setPincode] = useState("");
	const [pincodeInputState, setPincodeInputState] = useState("");
	const [pincodeError, setPincodeError] = useState("");

	const [anchal, setAnchal] = useState("");
	const [anchalInputState, setAnchalInputState] = useState("");
	const [anchalError, setAnchalError] = useState("");

	const [spiritualLevel, setSpiritualLevel] = useState(1);
	const [spiritualLevelState, setSpiritualLevelState] = useState("");
	const [spiritualLevelError, setSpiritualLevelError] = useState("");

	const [education, setEducation] = useState("");
	const [educationInputState, setEducationInputState] = useState("");
	const [educationError, setEducationError] = useState("");

	const [occupation, setOccupation] = useState("");
	const [occupationInputState, setOccupationInputState] = useState("");
	const [occupationError, setOccupationError] = useState("");

	const [isAgreedToTerms, setIsAgreedToTerms] = useState(false);
	const [isAgreedToTermsInputState, setIsAgreedToTermsInputState] = useState("");
	const [isAgreedToTermsError, setIsAgreedToTermsError] = useState("");

	const [buttonDisabled, setButtonDisabled] = useState(false);
	const [filteredAnchal, setFilteredAnchal] = useState([]);
	const [presetAnchal, setPresetAnchal] = useState("");

	const [formStateMapping, setFromStateMapping] = useState({
		city: {
			isSet: false,
			setErrorFunc: setCityError,
			setState: setCityInputState,
		},
		state: {
			isSet: false,
			setErrorFunc: setStateError,
			setState: setStateInputState,
		},
		address: {
			isSet: false,
			setErrorFunc: setAddressError,
			setState: setAddressInputState,
		},
		anchal: {
			isSet: false,
			setErrorFunc: setAnchalError,
			setState: setAnchalInputState,
		},
		spiritualLevel: {
			isSet: true,
			setErrorFunc: setSpiritualLevelError,
			setState: setSpiritualLevelState,
		},
		education: {
			isSet: false,
			setErrorFunc: setEducationError,
			setState: setEducationInputState,
		},
		occupation: {
			isSet: false,
			setErrorFunc: setOccupationError,
			setState: setOccupationInputState,
		},
		pincode: {
			isSet: false,
			setErrorFunc: setPincodeError,
			setState: setPincodeInputState,
		},
		termsAndConditions: {
			isSet: false,
			setErrorFunc: setIsAgreedToTermsError,
			setState: setIsAgreedToTermsInputState,
		},
	});

	const cityInput = useRef();
	const stateInput = useRef();
	const addressInput = useRef();
	const pincodeInput = useRef();
	const anchalInput = useRef();
	const spiritualOptions1Ref = useRef();
	const spiritualOptions2Ref = useRef();
	const spiritualOptions3Ref = useRef();
	const educationInput = useRef();
	const occupationInput = useRef();
	const isAgreedToTermsInput = useRef();

	useEffect(() => {
		spiritualOptions1Ref.current.checked = true;
	}, []);

	const validateField = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}

		return isError;
	};

	const handleCityChange = () => {
		setCityError("");
		const state = validateField(cityInput.current.value, setCityError, "public.city.error", "city");
		setCityInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setCity(cityInput.current.value);

		return state;
	};

	const handleStateChange = () => {
		setStateError("");
		const state = validateField(stateInput.current.value, setStateError, "public.state.error", "state");
		setStateInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setState(stateInput.current.value);

		return state;
	};

	const handleAddressChange = () => {
		setAddressError("");
		const state = validateField(addressInput.current.value, setAddressError, "public.address.error", "address");
		setAddressInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setAddress(addressInput.current.value);

		return state;
	};

	const handlePincodeChange = async () => {
		setPincodeError("");

		const state = validateField(pincodeInput.current.value, setPincodeError, "public.pincode.error", "pincode");
		setPincodeInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setPincode(pincodeInput.current.value);

		if (pincodeInput.current.value.length === 6) {
			setCity("");
			setPresetCity("");
			setPresetAnchal("");
			setFilteredAnchal([]);
			const payload = {
				pincode: pincodeInput.current.value,
			};
			const fetchPincodeDetailsResponse = await dispatch(fetchPincodeDetails(payload));
			if (fetchPincodeDetailsResponse) {
				formStateMapping.city.isSet = true;
				formStateMapping.state.isSet = true;

				setCity(fetchPincodeDetailsResponse.district);
				setPresetCity(fetchPincodeDetailsResponse.district);
				setState(pincodeDetails.state);

				const filteredMapping = ANCHAL_STATE_MAPPING.filter((item) => {
					return item.state.trim().toLowerCase() === fetchPincodeDetailsResponse.state.trim().toLowerCase();
				});

				if (filteredMapping.length && ANCHAL.indexOf(filteredMapping[0].anchal[0]) > -1) {
					const anchal = ANCHAL[ANCHAL.indexOf(filteredMapping[0].anchal[0])];
					setFilteredAnchal(filteredMapping[0].anchal);

					//preset the anchal only if one is present
					if (filteredMapping[0].anchal.length === 1) {
						setPresetAnchal(anchal);
						setAnchal(anchal);
					} else {
						setPresetAnchal("");
						setAnchal("");
					}

					setAnchalError("");
					formStateMapping.anchal.isSet = true;
				}

				setCityError("");
				setStateError("");

				setFromStateMapping(formStateMapping);
			}
		}

		return state;
	};

	const handleAnchalChange = (value) => {
		setAnchalError("");
		const state = validateField(anchalInput.current.value, setAnchalError, "public.anchal.error", "anchal");
		setAnchalInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setAnchal(anchalInput.current.value);

		return state;
	};

	const handleSpiritualChange = (e) => {
		let bitNumber = 1;

		if (spiritualOptions2Ref.current.checked) {
			bitNumber = 2;
		}

		if (spiritualOptions3Ref.current.checked) {
			bitNumber = 4;
		}

		if (spiritualOptions1Ref.current.checked && spiritualOptions2Ref.current.checked) {
			bitNumber = 3;
		}

		if (spiritualOptions1Ref.current.checked && spiritualOptions3Ref.current.checked) {
			bitNumber = 5;
		}

		if (spiritualOptions2Ref.current.checked && spiritualOptions3Ref.current.checked) {
			bitNumber = 6;
		}

		if (
			spiritualOptions1Ref.current.checked &&
			spiritualOptions2Ref.current.checked &&
			spiritualOptions3Ref.current.checked
		) {
			bitNumber = 7;
		}

		if (
			spiritualOptions1Ref.current.checked ||
			spiritualOptions2Ref.current.checked ||
			spiritualOptions3Ref.current.checked
		) {
			formStateMapping.spiritualLevel.isSet = true;
			setSpiritualLevelState(STATE_DEFAULT);
			setSpiritualLevel(bitNumber);
			setSpiritualLevelError("");
			setButtonDisabled(false);
		} else {
			formStateMapping.spiritualLevel.isSet = false;
			setSpiritualLevelState(STATE_DANGER);
			setSpiritualLevel("");
			setSpiritualLevelError(formatMessage({ id: "public.spiritual.error" }));
			setButtonDisabled(true);
		}
	};

	const handleEducationChange = () => {
		setEducationError("");
		const state = validateField(
			educationInput.current.value,
			setEducationError,
			"public.education.error",
			"education"
		);
		setEducationInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEducation(educationInput.current.value);

		return state;
	};

	const handleOccupationChange = () => {
		setOccupationError("");
		const state = validateField(
			occupationInput.current.value,
			setOccupationError,
			"public.occupation.error",
			"occupation"
		);
		setOccupationInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setOccupation(occupationInput.current.value);

		return state;
	};

	const handleOnAgreeTermsChange = (e) => {
		formStateMapping.termsAndConditions.isSet = e.target.checked;
		setIsAgreedToTerms(e.target.checked);

		if (!e.target.checked) {
			setIsAgreedToTermsError(formatMessage({ id: "volunteer.registration.isAgreedToTermsError" }));
			setButtonDisabled(true);
		} else {
			setIsAgreedToTermsError("");
			setIsAgreedToTermsInputState(STATE_DEFAULT);
			setButtonDisabled(false);
		}
	};

	const handleNextClick = () => {
		let unsetData = {};

		for (let key in formStateMapping) {
			if (!formStateMapping[key].isSet) {
				let item = {};
				item[key] = formStateMapping[key];
				unsetData = {
					...unsetData,
					...item,
				};
			}
		}

		if (Object.keys(unsetData).length) {
			for (let key in unsetData) {
				if (!unsetData[key].isSet && unsetData[key].setErrorFunc) {
					unsetData[key].setErrorFunc(formatMessage({ id: "public.register.mandatoryFieldError" }));

					if (unsetData[key].setState) {
						unsetData[key].setState(STATE_DANGER);
					}
				}
			}

			return;
		}

		onNextButtonClick({
			city: city || presetCity,
			state: state || pincodeDetails.state,
			address,
			pinCode: pincode,
			region: anchal || presetAnchal,
			knowledgeStatus: spiritualLevel,
			education,
			occupation,
			termsAndConditions: isAgreedToTerms,
		});
	};

	return (
		<>
			<div className="row mt-16">
				<div className="col-lg-6">
					<CustomInput
						id="pincode"
						label="public.pincode"
						icon={faMapLocation}
						isMandatory={true}
						placeholder="public.pincode.placeholder"
						ref={pincodeInput}
						state={pincodeInputState}
						max={6}
						onChange={handlePincodeChange}
					/>
					<div className="text-left text text-body--5">
						{formatMessage({ id: "public.register.pincodeInfo" })}
					</div>
					{pincodeError && <div className="text text-body--5 text-left text-danger">{pincodeError}</div>}
				</div>
				<div className="col-lg-6">
					<CustomInput
						id="city"
						label="public.city"
						icon={faLocationArrow}
						isMandatory={true}
						placeholder="public.city.placeholder"
						ref={cityInput}
						state={cityInputState}
						value={city ? city : presetCity ? presetCity : ""}
						loading={fetchingPincodeDetails}
						onChange={handleCityChange}
					/>
					{cityError && <div className="text text-body--5 text-left text-danger">{cityError}</div>}
				</div>
			</div>

			<div className="row mt-16">
				<div className="col-lg-6">
					<Dropdown
						id="state"
						label="public.state"
						icon={faLocationArrow}
						isMandatory={true}
						placeholder="public.state.placeholder"
						ref={stateInput}
						state={stateInputState}
						options={STATES}
						value={pincodeDetails ? pincodeDetails.state : ""}
						disabled={pincodeDetails && pincodeDetails.state ? true : false}
						loading={fetchingPincodeDetails}
						onChange={handleStateChange}
					/>
					{stateError && <div className="text text-body--5 text-left text-danger">{stateError}</div>}
				</div>
				<div className="col-lg-6">
					<CustomInput
						id="address"
						label="public.address"
						icon={faLocationCrosshairs}
						isMandatory={true}
						placeholder="public.address.placeholder"
						ref={addressInput}
						state={addressInputState}
						onChange={handleAddressChange}
					/>
					{addressError && <div className="text text-body--5 text-left text-danger">{addressError}</div>}
				</div>
			</div>

			<div className="row mt-16">
				<div className="col-lg-6">
					<Dropdown
						id="anchal"
						label="public.anchal"
						icon={faMapLocation}
						isMandatory={true}
						placeholder="public.anchal.placeholder"
						ref={anchalInput}
						state={anchalInputState}
						options={filteredAnchal.length ? filteredAnchal : ANCHAL}
						loading={fetchingPincodeDetails}
						value={presetAnchal ? presetAnchal : ""}
						onChange={handleAnchalChange}
					/>
					{anchalError && <div className="text text-body--5 text-left text-danger">{anchalError}</div>}
				</div>
			</div>

			<div className="row mt-16">
				<div className="col-lg-12">
					<div className="flex direction-row align-items-center">
						<div className="text text-body--4 text-left">{formatMessage({ id: "public.spiritual" })}</div>
						<span className="input-mandatory-sign ml-8">*</span>
					</div>
				</div>
				<div className="col-lg-12 flex direction-row align-items-cente mt-8">
					<Checkbox
						label="public.spiritual.option1"
						state={spiritualLevelState}
						ref={spiritualOptions1Ref}
						onChange={handleSpiritualChange}
					/>
					<Checkbox
						className="ml-16"
						label="public.spiritual.option2"
						state={spiritualLevelState}
						ref={spiritualOptions2Ref}
						onChange={handleSpiritualChange}
					/>
					<Checkbox
						className="ml-16"
						label="public.spiritual.option3"
						state={spiritualLevelState}
						ref={spiritualOptions3Ref}
						onChange={handleSpiritualChange}
					/>
				</div>
				{spiritualLevelError && (
					<div className="text text-body--5 text-left text-danger">{spiritualLevelError}</div>
				)}
			</div>

			<div className="row mt-16">
				<div className="col-lg-6">
					<Dropdown
						id="education"
						label="public.education"
						icon={faSchool}
						isMandatory={true}
						placeholder="public.education.placeholder"
						ref={educationInput}
						state={educationInputState}
						options={EDUCATION}
						onChange={handleEducationChange}
					/>
					{educationError && <div className="text text-body--5 text-left text-danger">{educationError}</div>}
				</div>
				<div className="col-lg-6">
					<CustomInput
						id="occupation"
						label="public.occupation"
						icon={faSuitcase}
						isMandatory={true}
						placeholder="public.occupation.placeholder"
						ref={occupationInput}
						state={occupationInputState}
						onChange={handleOccupationChange}
					/>
					{occupationError && (
						<div className="text text-body--5 text-left text-danger">{occupationError}</div>
					)}
				</div>
			</div>

			<div className="flex direction-col align-items-start mt-16">
				<Checkbox
					label="public.termsAndConditions.placeholder"
					isMandatory={true}
					ref={isAgreedToTermsInput}
					state={isAgreedToTermsInputState}
					onChange={handleOnAgreeTermsChange}
				/>
				{isAgreedToTermsError && (
					<div className="text text-body--5 text-left text-danger">{isAgreedToTermsError}</div>
				)}
			</div>

			<div className="row  pb-16">
				<div className="col-lg-12 flex direction-col align-items-end">
					{genericErrorMessage && <div className="text text-body--4 text-danger">{genericErrorMessage}</div>}
					<Button
						className="button-primary mt-16"
						label="public.action.submit"
						disabled={buttonDisabled}
						loading={fetchingPincodeDetails}
						onClick={handleNextClick}
					/>
				</div>
			</div>
		</>
	);
});
